import { combineReducers } from "redux";
import { reducer as toastrReducer } from "react-redux-toastr";

import sidebar from "./sidebarReducers";
import theme from "./themeReducer";
import client from "./clientReducer";
import user from "./userReducer";
import debug from "./debugReducer";
import layout from "./layoutReducer";
import locations from "./locationsReducer";
import workflows from "./workflowReducer";
import communications from "./communicationReducer";
import appointments from "./appointmentReducer";
import billings from "./billingReducer";

export default combineReducers({
  sidebar,
  theme,
  layout,
  toastr: toastrReducer,
  client,
  user,
  debug,
  locations,
  communications,
  workflows,
  appointments,
  billings,
});
